import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";

const locations = [
  {
    city: "Queens, NY",
    address: "89-14 Queens Boulevard, Suite 205\nElmhurst, NY 11373",
    phone: "(718) 555-0247",
  },
  {
    city: "The Bronx, NY",
    address: "301 East 138th Street\nBronx, NY 10454",
    phone: "(347) 555-0362",
  },
  {
    city: "Staten Island, NY",
    address: "240 Richmond Valley Road\nStaten Island, NY 10309",
    phone: "(917) 555-0425",
  },
  {
    city: "Jersey City, NJ",
    address: "123 Newark Avenue, Suite 4A\nJersey City, NJ 07302",
    phone: "(201) 555-0563",
  },
];

const MoreLocationsSection = () => {
  return (
    <Box
      sx={{
        position: "relative",
        py: { xs: 6, md: 10 },
        borderRadius: "40px",
        backgroundImage:
          "url(https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/background_02.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container maxWidth="xl">
        {/* HEADER */}
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h4"
            fontWeight={700}
            color="#fff"
          >
            More Locations by Qleen
          </Typography>
        </Box>

        {/* FLOATING DECOR IMAGES (DESKTOP ONLY) */}
        <Box
          component="img"
          src="https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/floating_contact_01.png"
          sx={{
            position: "absolute",
            top: -40,
            left: 40,
            display: { xs: "none", lg: "block" },
            width: 180,
          }}
        />

        <Box
          component="img"
          src="https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/floating_contact_02.png"
          sx={{
            position: "absolute",
            bottom: 40,
            right: 40,
            display: { xs: "none", lg: "block" },
            width: 120,
          }}
        />

        {/* LOCATION CARDS */}
        <Grid container spacing={2} justifyContent="center">
          {locations.map((loc, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 4,
                  p: 1,
                }}
              >
                <CardContent>
                  <LocationOnIcon
                    sx={{ color: "#ff8a00", fontSize: 32 }}
                  />

                  <Typography
                    variant="h6"
                    fontWeight={600}
                    mt={2}
                  >
                    {loc.city}
                  </Typography>

                  <Typography
                    mt={1}
                    color="text.secondary"
                    whiteSpace="pre-line"
                  >
                    {loc.address}
                  </Typography>

                  <Box
                    display="flex"
                    alignItems="center"
                    mt={2}
                  >
                    <PhoneIcon
                      sx={{ fontSize: 18, mr: 1 }}
                    />
                    <Typography fontWeight={600}>
                      {loc.phone}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default MoreLocationsSection;
